/** @format */

import styled from 'styled-components';

export const PreviewImageWrapper = styled.div`
	width: 100%;
	height: 278px;
	background: #ffffff;
	background-repeat: no-repeat;
	background-position: center center;
	background-image: url(${(props) => props.src});
	border-radius: 20px 20px 0px 0px;
`;

export const PreviewBodyContainer = styled.div`
	padding: 16px;
	background: #ffffff;
	border-radius: 0px 0px 20px 20px;
`;

export const PreviewTitleWrapper = styled.div`
	overflow: hidden;
	font-size: 12px;
	line-height: 17px;
	color: rgba(61, 57, 44, 0.4);
`;

export const PreviewContentWrapper = styled.div`
	width: 100%;
	font-size: 16px;
	line-height: 23px;
	color: #3d392c;
	margin-top: 7px;
`;
